import { render } from "./WatchlistButton.vue?vue&type=template&id=3cb6559b&scoped=true"
import script from "./WatchlistButton.vue?vue&type=script&lang=js"
export * from "./WatchlistButton.vue?vue&type=script&lang=js"

import "./WatchlistButton.vue?vue&type=style&index=0&id=3cb6559b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb6559b"]])

export default __exports__